// extracted by mini-css-extract-plugin
module.exports = {"header":"W_bf","headerContent":"W_dn","questionsNav":"W_fk","questionsNavContent":"W_fl","questionsContainer":"W_fm","questionsContent":"W_fn","banner":"W_l"};